import React from "react";

import { I18nProvider } from "./src/i18n";

export const wrapRootElement = ({ element }) => (
  <I18nProvider>{element}</I18nProvider>
);
